import "react-phone-input-2/lib/style.css";
import toast from "react-hot-toast";
import classes from "./AddLaundry.module.css";
import PhoneInput from "react-phone-input-2";
import ModalWrapper from "../modalWrapper/ModalWrapper";
import MapboxComponent from "../mapboxComponent/MapboxComponent";
import { CloseIcon } from "../../images/deliveries/deliveriesModals/xIcon";
import { ActionBtn } from "../buttons/actionBtn/ActionBtn";
import { useLocation } from "react-router-dom";
import { InputElement } from "../inputElement/InputElement";
import { LoadingSpinner } from "../loadingSpinner/LoadingSpinner";
import { useStatusEffect } from "../../helperFunctions/customHooks/useStatusEffect";
import { useTranslations } from "../../helperFunctions/customHooks/useTranslations";
import { createDepartment } from "../../redux/department/thunks/createDepartmentThunk";
import { fetchDepartments } from "../../redux/department/thunks/getDepartmentThunk";
import { updateDepartment } from "../../redux/department/thunks/updateDepartmentThunk";
import { validateRequiredFields } from "../../helperFunctions/validateRequiredFields";
import { useDispatch, useSelector } from "react-redux";
import { resetCreateDepartmentStatus } from "../../redux/department/slices/createDepartmentSlice";
import { resetUpdateDepartmentStatus } from "../../redux/department/slices/updateDepartmentSlice";
import { useEffect, useRef, useState } from "react";
import {
  toggleAddLaundry,
  setIsEditMode,
  setIsEditModalShown,
  setIsModalsBgShown,
  setAddressData,
  setSelectedAddress,
  setIsFetchCurrentAddress,
  setIsNewPickupAddressCreated,
  setSelectedDataForEdit,
} from "../../redux/globalFunctions/globalFnSlice";
import {
  resetDepartmentForm,
  setDepartmentForm,
} from "../../redux/forms/departmentForm";

export function AddLaundry() {
  const { isEditMode, selectedDataForEdit, addressData } = useSelector(
    (state) => state.global
  );
  const formData = useSelector((state) => state.forms.departmentForm);
  const createDepartmentState = useSelector((state) => state.createDepartment);
  const updateDepartmentState = useSelector((state) => state.updateDepartment);

  const prevEditModeRef = useRef(null);
  const dispatch = useDispatch();
  const location = useLocation();
  const { t } = useTranslations();

  const modalText = t.addLaundryModal;
  const validationText = t.formValidations;

  const [suggestions, setSuggestions] = useState([]);
  const [hasSearched, setHasSearched] = useState(false);
  const [countryCode, setCountryCode] = useState("us");
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [localPhone, setLocalPhone] = useState("");
  const [address, setAddress] = useState("");

  useEffect(() => {
    if (formData.address === "") {
      dispatch(setIsFetchCurrentAddress(false));
    } else {
      dispatch(setIsFetchCurrentAddress(true));
    }
  }, [formData.address]);

  // Update address and coordinates when map is used
  useEffect(() => {
    if (addressData && addressData?.length !== 0) {
      // Filter addresses based on relevance
      const validAddresses = addressData.filter(
        (item) => item?.relevance >= 0.5
      );

      // Only show suggestions if there are valid addresses
      if (validAddresses.length > 0) {
        const suggestedAddresses = validAddresses.map(
          (item) => item.place_name
        );
        setSuggestions(suggestedAddresses);
      } else {
        setSuggestions([]);
      }

      const firstAddress = addressData[0];
      const geometry = firstAddress?.center;

      const latitude = geometry[1];
      const longitude = geometry[0];

      dispatch(
        setDepartmentForm({
          latitude: latitude,
          longitude: longitude,
        })
      );
    } else {
      setSuggestions([]);
    }
  }, [addressData]);

  const changeAddress = (newAddress, latitude, longitude) => {
    setAddress(newAddress);

    dispatch(
      setDepartmentForm({
        address: newAddress,
        latitude: latitude || prevData.latitude,
        longitude: longitude || prevData.longitude,
      })
    );
  };

  useEffect(() => {
    if (formData.address !== "" && addressData.length !== 0) {
      const context =
        addressData[isEditMode ? 0 : selectedIndex]?.context || [];
      const foundCity =
        context.find((entry) => entry.id.startsWith("place"))?.text || "";
      const foundCountry =
        context.find((entry) => entry.id.startsWith("country"))?.text || "";
      const postalCode =
        context.find((entry) => entry.id.startsWith("postcode"))?.text || "";

      dispatch(
        setDepartmentForm({
          city: foundCity,
          country: foundCountry,
          postalCode: postalCode,
        })
      );
    }
  }, [formData.address, addressData]);

  const handleInputChange = (e) => {
    const { id, value } = e.target;

    // For other fields, just update the state
    dispatch(setDepartmentForm({ [id]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const requiredFields = ["name", "phone", "address"];

    const errors = validateRequiredFields(
      formData,
      requiredFields,
      validationText
    );

    if (errors.length > 0) {
      toast.dismiss();
      setTimeout(() => {
        errors.forEach((err) => toast.error(err, { duration: 2000 }));
      }, 100);
      return;
    }

    if (isEditMode) {
      dispatch(
        updateDepartment({ d_id: selectedDataForEdit.d_id, ...formData })
      );
    } else {
      dispatch(createDepartment(formData));
    }
  };

  // Populate fields with data if edit mode is true and there is data present.
  useEffect(() => {
    if (isEditMode && selectedDataForEdit) {
      dispatch(setSelectedAddress(selectedDataForEdit.d_address));
      dispatch(
        setDepartmentForm({
          name: selectedDataForEdit.d_name || "",
          address: selectedDataForEdit.d_address || "",
          latitude: selectedDataForEdit.d_latitude || "",
          longitude: selectedDataForEdit.d_longitude || "",
        })
      );
    }
  }, [isEditMode, selectedDataForEdit]);

  useEffect(() => {
    if (selectedDataForEdit) {
      dispatch(
        setDepartmentForm({ phone: selectedDataForEdit.d_phonenumber || "" })
      );
    }
  }, [countryCode]);

  useEffect(() => {
    if (
      createDepartmentState.status === "success" ||
      updateDepartmentState.status === "success"
    ) {
      dispatch(setIsFetchCurrentAddress(false));
      setLocalPhone("");
    }
  }, [createDepartmentState.status, updateDepartmentState.status]);

  useStatusEffect({
    status: createDepartmentState.status,
    successMessage: modalText.successCreated,
    errorMessage: modalText.errorCreating + " " + createDepartmentState.error,
    onSuccess: toggleAddLaundry,
    reFetch: fetchDepartments,
    resetStatus: resetCreateDepartmentStatus,
    onError: toggleAddLaundry,
    resetForm: resetDepartmentForm,
  });

  useStatusEffect({
    status: updateDepartmentState.status,
    successMessage: modalText.successUpdating,
    errorMessage: modalText.errorUpdating + " " + updateDepartmentState.error,
    onSuccess: toggleAddLaundry,
    reFetch: fetchDepartments,
    resetStatus: resetUpdateDepartmentStatus,
    onError: toggleAddLaundry,
    resetForm: resetDepartmentForm,
    resetEditMode: true,
    resetSelectedDataForEdit: true,
  });

  // Handler for createDepartment status
  useEffect(() => {
    if (createDepartmentState.status === "success") {
      if (prevEditModeRef.current) {
        dispatch(setIsEditMode(true));
        prevEditModeRef.current = false;
      }
      if (location.pathname !== "/addresses") {
        dispatch(setIsNewPickupAddressCreated(true));
      }
    }
  }, [createDepartmentState.status, dispatch]);

  const isStatusLoading =
    createDepartmentState.status === "loading" ||
    updateDepartmentState.status === "loading";

  function handleCloseModal() {
    if (
      location.pathname === "/deliveries" ||
      location.pathname === "/dashboard" ||
      location.pathname === "/scheduled-deliveries"
    ) {
      dispatch(setIsFetchCurrentAddress(false));
      dispatch(toggleAddLaundry());
      dispatch(setIsModalsBgShown(true));
      dispatch(setIsEditModalShown(true));
      /*  dispatch(resetDepartmentForm()); */

      if (prevEditModeRef.current) {
        dispatch(setIsEditMode(true));
        prevEditModeRef.current = false;
      }
    } else if (isEditMode) {
      dispatch(toggleAddLaundry());
      dispatch(resetDepartmentForm());
      dispatch(setAddressData(""));
      setLocalPhone("");
      dispatch(setSelectedDataForEdit(null));
      dispatch(setIsFetchCurrentAddress(false));
    } else {
      dispatch(toggleAddLaundry());
      /*  dispatch(resetDepartmentForm()); */
    }
    dispatch(setSelectedAddress(null));
    dispatch(setAddressData(""));
  }

  useEffect(() => {
    if (
      location.pathname === "/deliveries" ||
      location.pathname === "/dashboard" ||
      location.pathname === "/scheduled-deliveries"
    ) {
      // Save the current value of isEditMode before disabling it
      if (isEditMode) {
        prevEditModeRef.current = true;
      }
      dispatch(setIsEditMode(false));
    }
  }, [location.pathname, dispatch]);

  useEffect(() => {
    if (
      (location.pathname === "/deliveries" ||
        location.pathname === "/dashboard" ||
        location.pathname === "/scheduled-deliveries") &&
      createDepartmentState.status === "success"
    ) {
      setTimeout(() => {
        dispatch(setIsModalsBgShown(true));
        dispatch(setIsEditModalShown(true));
      }, 2000);
    }
  }, [createDepartmentState.status]);

  const headerText = isEditMode ? modalText.editText : modalText.addText;

  function onAddressClick(item, index) {
    setSelectedIndex(index);
    dispatch(setSelectedAddress(item));
    dispatch(setDepartmentForm({ address: item }));
    setHasSearched(false);
  }

  useEffect(() => {
    if (formData.address && addressData.length !== 0) {
      if (addressData[0].properties.short_code) {
        const code = addressData[0]?.properties?.short_code;
        const countryCode = code.split("-")[0];
        setCountryCode(countryCode);
        dispatch(setDepartmentForm({ countryCode: countryCode }));
        setTimeout(() => {
          setLocalPhone(formData.phone);
        }, 100);
      } else if (addressData[0].context) {
        const countryContext = addressData[0]?.context.find((entry) =>
          entry.id.startsWith("country")
        );
        if (countryContext) {
          const shortCode = countryContext.short_code;
          setCountryCode(shortCode);
          dispatch(setDepartmentForm({ countryCode: shortCode }));
          setTimeout(() => {
            setLocalPhone(formData.phone);
          }, 100);
        } else {
          setCountryCode("us");
          dispatch(setDepartmentForm({ countryCode: "us" }));
        }
      } else {
        setCountryCode("us");
        dispatch(setDepartmentForm({ countryCode: "us" }));
      }
    } else {
      return;
    }
  }, [formData.address, addressData]);

  function handleCloseDropdowns() {
    setHasSearched(false);
  }

  function handleFocusAddress() {
    if (suggestions.length !== 0 && address !== "") {
      setHasSearched(true);
    }
  }

  function handleAddressOnChange(e) {
    dispatch(setSelectedAddress(null));
    setAddress(e.target.value);
  }

  function handleResetForm() {
    dispatch(setIsFetchCurrentAddress(false));
    dispatch(resetDepartmentForm());
    setLocalPhone("");
  }

  function handleSearchClick() {
    if (address === "") return;
    setHasSearched(true);
    dispatch(setDepartmentForm({ address: address }));
  }

  function onKeyDownSearch(e) {
    if (e.key === "Enter" && address !== "") {
      e.preventDefault();
      dispatch(setDepartmentForm({ address: address }));
      setTimeout(() => {
        setHasSearched(true);
      }, 100);
    }
  }

  useEffect(() => {
    if (address === "") {
      setHasSearched(false);
    }
  }, [address]);

  const resetButton = [
    <ActionBtn
      text={t.addDeliveryModal.reset}
      onClick={handleResetForm}
      disabled={isEditMode}
    />,
  ];

  return (
    <ModalWrapper
      title={headerText}
      onClick={handleCloseModal}
      resetButton={resetButton}
    >
      <form className={classes.form}>
        <InputElement
          labelText={modalText.form.name}
          onChange={handleInputChange}
          value={formData.name || ""}
          id={"name"}
        />
        <InputElement
          labelText={modalText.form.country}
          value={formData.country || ""}
          readOnly={true}
          disabled={true}
          type={"text"}
          id={"country"}
        />
        <InputElement
          labelText={modalText.form.city}
          value={formData.city || ""}
          readOnly={true}
          disabled={true}
          type={"text"}
          id={"city"}
        />
        <InputElement
          labelText={modalText.form.postalCode}
          value={formData.postalCode || ""}
          readOnly={true}
          disabled={true}
          type={"text"}
          id={"postalCode"}
        />

        <div className={classes.formElementAddress}>
          <div className={classes.searchContainer}>
            <div style={{ width: "100%" }}>
              <label htmlFor="address">{modalText.form.address}</label>
              <input
                type="text"
                id="address"
                value={address || ""}
                onFocus={handleFocusAddress}
                onChange={(e) => handleAddressOnChange(e)}
                onKeyDown={onKeyDownSearch}
                required
              />
            </div>
            <ActionBtn onClick={handleSearchClick} text={modalText.search} />
          </div>

          {suggestions.length !== 0 && address.length !== 0 && hasSearched && (
            <div className={classes.suggestionsContainer}>
              <button
                onClick={handleCloseDropdowns}
                className={classes.closeBtn}
              >
                <CloseIcon />
              </button>

              {suggestions.map((item, index) => (
                <span key={index} onClick={() => onAddressClick(item, index)}>
                  {item}
                </span>
              ))}
            </div>
          )}
          {suggestions.length === 0 && address.length !== 0 && hasSearched && (
            <span className={classes.noResultsFound}>
              {modalText.noResultsFound}
            </span>
          )}
        </div>

        <div className={classes.formElement}>
          <label htmlFor="phone">{modalText.form.phone}</label>
          <PhoneInput
            key={isEditMode ? "edit" : "create"}
            country={countryCode.toLocaleLowerCase() || "us"}
            value={localPhone || ""}
            onChange={(value) => {
              setLocalPhone(value);
              dispatch(setDepartmentForm({ phone: value }));
            }}
            inputProps={{
              name: "phone",
              required: true,
            }}
            containerClass="phone-input-container"
            inputClass="phone-input"
            enableSearch={true}
            countryCodeEditable={false}
          />
        </div>
        <MapboxComponent
          address={formData.address || ""}
          country={formData.country || ""}
          city={formData.city || ""}
          updateAddress={changeAddress}
        />
      </form>
      <ActionBtn
        width={"100%"}
        height={"42px"}
        onClick={handleSubmit}
        disabled={isStatusLoading}
        text={isStatusLoading ? <LoadingSpinner /> : modalText.saveBtn}
      />
    </ModalWrapper>
  );
}
